exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-21b7cd4d] .el-dialog__body{padding-top:15px;padding-right:0;border-top:1px solid #dcdfe6}.paginationClass[data-v-21b7cd4d]{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}\n", ""]);

// exports
